function findInsuranceFormSection() {
  const section =
    document.getElementById('ServiceProvider') ||
    document
      .querySelector(
        '#insuranceIdentity, #insurance-weg, [id^="insurance-building-"]'
      )
      ?.closest('.FormSection')
  return section && section.id !== 'ContactRolesSection' ? section : null
}

/** Impower's section markup, so the Lux overview replaces native section 8 in place. */
function createInsuranceFormSection(number) {
  const section = document.createElement('div')
  section.className = 'FormSection'
  section.id = LUX_INSURANCE_FORM_SECTION_ID
  section.innerHTML = `<div class="form-section-wrapper open"><div class="main-section-header section-header open"><div class="section-number-box open"><div class="section-number">${escapeHtml(number)}</div></div><div class="section-title-box open"><div class="section-title">Versicherungen</div></div></div><div class="section-content"></div></div>`
  const header = section.querySelector('.main-section-header')
  header.addEventListener('click', () => {
    const open = header.classList.contains('not-open')
    header.classList.toggle('open', open)
    header.classList.toggle('not-open', !open)
    for (const box of section.querySelectorAll(
      '.form-section-wrapper, .section-number-box, .section-title-box'
    )) {
      box.classList.toggle('open', open)
    }
    section.querySelector('.section-content').hidden = !open
  })
  return section
}

function propertySectionNumber(section) {
  const number = parseInt(
    section?.querySelector('.section-number')?.textContent,
    10
  )
  return Number.isInteger(number) ? number : null
}

// MV/SEV property pages have no native insurance section, so the overview adds its own after the highest numbered one.
// The unnumbered Benachrichtigungseinstellungen section can sit anywhere and is never the anchor.
function lastNumberedPropertySection() {
  let last = null
  for (const section of document.querySelectorAll(
    `.FormSection:not(#${LUX_INSURANCE_FORM_SECTION_ID})`
  )) {
    const number = propertySectionNumber(section)
    if (number !== null && number >= (last?.number ?? 0)) {
      last = { section, number }
    }
  }
  return last
}

// Lux's own Zählerstände section follows the overview; Impower's sections always stay above it.
function luxSectionAfterInsurance() {
  const section = document.getElementById('MeterReadingsSection')
  const number = propertySectionNumber(section)
  return number === null ? null : { section, number }
}

/** Renumbers the other sections and Lux sidebar entries from `from` on, keeping the order gap-free. */
function shiftPropertySectionNumbers(from, delta) {
  for (const node of document.querySelectorAll(
    `.FormSection:not(#${LUX_INSURANCE_FORM_SECTION_ID}) .section-number`
  )) {
    const number = parseInt(node.textContent, 10)
    if (number >= from) node.textContent = String(number + delta)
  }
  for (const title of document.querySelectorAll(
    `.FormSidebar .Link.main-link[data-section-id]:not([data-section-id="${LUX_INSURANCE_FORM_SECTION_ID}"]) .link-title`
  )) {
    title.textContent = title.textContent.replace(/^\d+(?=\s)/, (number) =>
      Number(number) >= from ? String(Number(number) + delta) : number
    )
  }
}

// Next to the neighbouring section's entry rather than at the end, where Benachrichtigungseinstellungen may sit.
function insertInsuranceSidebarLink(link, number, nextSectionId) {
  const links = [
    ...document.querySelectorAll('.FormSidebar .Link.main-link'),
  ].filter((item) => item !== link)
  const nextLink = nextSectionId
    ? links.find((item) => item.dataset.sectionId === nextSectionId)
    : null
  if (nextLink) return nextLink.before(link)
  const previousLink = links.find(
    (item) =>
      parseInt(item.querySelector('.link-title')?.textContent, 10) ===
      number - 1
  )
  if (previousLink) previousLink.after(link)
  else links[links.length - 1]?.after(link)
}

function createInsuranceSidebarLink(number, section) {
  const link = document.createElement('div')
  link.className = 'Link main-link'
  link.dataset.sectionId = LUX_INSURANCE_FORM_SECTION_ID
  link.innerHTML = `<div class="link-row level1 arrow-placeholder"><div class="link-title" role="button" tabindex="-1">${escapeHtml(number)}&nbsp;&nbsp;&nbsp;&nbsp;Versicherungen</div></div>`
  link.addEventListener('click', () => {
    document
      .querySelectorAll('.FormSidebar .Link.main-link .link-row')
      .forEach((row) => row.classList.remove('active'))
    link.querySelector('.link-row').classList.add('active')
    section.scrollIntoView({ block: 'start', behavior: 'smooth' })
  })
  return link
}

function ensureInsurancePendingStyles() {
  if (document.getElementById('luxInsurancePendingStyles')) return
  const style = document.createElement('style')
  style.id = 'luxInsurancePendingStyles'
  style.textContent = LUX_INSURANCE_PENDING_STYLES
  document.head.appendChild(style)
}

/**
 * Shown until the first load settles: the overview's own frame (title, create
 * button, disabled filters, table header) with a spinner row, like the
 * Technische Anlagen tables — not a bare loading line. `mount()` replaces it
 * with the real overview, so the swap keeps the layout.
 */
function createInsurancePendingLoader(propertyHrId = '', buildings = []) {
  const loader = document.createElement('section')
  loader.id = 'insurancePoliciesLuxPending'
  loader.className = 'sub-section impowerx-insurance-lux-root'
  loader.setAttribute('aria-busy', 'true')
  loader.innerHTML = insuranceOverviewShellHtml(
    propertyHrId,
    buildings,
    true,
    []
  )
  // The overview styles are scoped to the mounted root's id.
  const style = loader.querySelector('style')
  if (style) {
    style.textContent = LUX_INSURANCE_OVERVIEW_STYLES.split(
      '#insurancePoliciesLux'
    ).join('#insurancePoliciesLuxPending')
  }
  loader.querySelector('[data-insurance-table]').innerHTML =
    renderInsuranceTable([], propertyHrId, buildings, {
      loading: true,
      buildingsLoaded: true,
    })
  return loader
}

function createInsuranceNavigatingOverlay() {
  const overlay = document.createElement('div')
  overlay.className = 'lux-ins-navigating'
  overlay.setAttribute('role', 'status')
  overlay.innerHTML =
    '<span class="lux-ins-spinner" aria-hidden="true"></span>Wird geöffnet…'
  return overlay
}

function filterInsuranceRows(rows, buildings, { search, building, kind }) {
  return rows.filter((policy) => {
    const text = [
      policy.policyNumber,
      policy.insurer?.companyName,
      policy.insurer?.firstName,
      policy.insurer?.lastName,
      policy.types
        .map((kind) => LUX_INSURANCE_KIND_LABELS[kind] || kind)
        .join(' '),
      insuranceCoverageLabel(policy, buildings),
    ]
      .join(' ')
      .toLocaleLowerCase('de')
    return (
      (!search || text.includes(search)) &&
      (!kind || policy.types.includes(kind)) &&
      (!building ||
        policy.assignments.some(
          (row) =>
            (!kind || row.coverageKind === kind) &&
            (row.buildingId === null || String(row.buildingId) === building)
        ))
    )
  })
}

async function luxInsuranceRequest(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: { Accept: 'application/json', ...options.headers },
  })
  if (!response.ok) {
    const data = await response.json().catch(() => null)
    throw new Error(
      response.status === 401
        ? 'Bitte erneut anmelden.'
        : data?.error ||
            'Versicherungen konnten nicht geladen oder gespeichert werden.'
    )
  }
  return response.status === 204 ? null : response.json()
}

// Kinds the property's administration type allows (WEG-only ones are missing for MV/SEV),
// plus any kind an existing policy still has, so legacy records stay findable.
function insuranceFilterKinds(allowedKinds, rows) {
  const used = new Set(rows.flatMap((row) => row.types))
  return Object.keys(LUX_INSURANCE_KIND_LABELS).filter(
    (kind) => !allowedKinds || allowedKinds.includes(kind) || used.has(kind)
  )
}

function insuranceKindOptionsHtml(kinds) {
  return `<option value="">Sparte: Alle</option>${kinds
    .map(
      (kind) =>
        `<option value="${escapeHtml(kind)}">${escapeHtml(LUX_INSURANCE_KIND_LABELS[kind])}</option>`
    )
    .join('')}`
}

function insuranceOverviewShellHtml(
  propertyHrId,
  buildings,
  buildingsLoaded,
  kinds
) {
  // Same `.sub-section-header` / `.sub-section-content` frame as the Technische
  // Anlagen tables, so Impower indents both tables identically.
  return `<style>${LUX_INSURANCE_OVERVIEW_STYLES}</style>
      <div class="lux-ins-header sub-section-header"><div class="sub-section-title">Versicherungen<span class="impowerx-ta-title-count" data-insurance-total-count></span></div><a class="lux-ins-create" href="${escapeHtml(luxInsuranceUrl(propertyHrId))}">Versicherung hinzufügen</a></div>
      <div class="lux-ins-body sub-section-content">
      <div class="lux-ins-controls"><div class="lux-ins-filters"><span class="lux-ins-muted">Filter:</span><select data-insurance-building aria-label="Nach Baukörper filtern" disabled><option value="">Geltungsbereich: Alle</option>${buildings.map((building) => `<option value="${escapeHtml(building.id)}">${escapeHtml(building.name || `Gebäude ${building.id}`)}</option>`).join('')}</select><select data-insurance-kind aria-label="Nach Sparte filtern" disabled>${insuranceKindOptionsHtml(kinds)}</select></div>
        <label class="lux-ins-search">${insuranceOverviewIcon('search')}<input class="ant-input" type="search" data-insurance-search aria-label="Policen suchen" placeholder="Nach Versicherungsname oder Nummer…" disabled></label></div>
      ${buildingsLoaded ? '' : '<p class="lux-ins-warning" role="status">Gebäudezuordnung nicht verfügbar. Bitte die Objektseite erneut laden.</p>'}
      <p data-insurance-status role="status" aria-live="polite"></p><div data-insurance-table></div>
      </div>`
}

async function copyInsurancePolicyNumber(policy) {
  try {
    await navigator.clipboard.writeText(policy.policyNumber)
    showToast('Policennummer kopiert.', 'success')
  } catch (_) {
    showToast('Policennummer konnte nicht kopiert werden.', 'error')
  }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    findInsuranceFormSection,
    createInsuranceFormSection,
    lastNumberedPropertySection,
    luxSectionAfterInsurance,
    shiftPropertySectionNumbers,
    insertInsuranceSidebarLink,
    createInsuranceSidebarLink,
    ensureInsurancePendingStyles,
    createInsurancePendingLoader,
    createInsuranceNavigatingOverlay,
    filterInsuranceRows,
    luxInsuranceRequest,
    insuranceFilterKinds,
    insuranceKindOptionsHtml,
    insuranceOverviewShellHtml,
    copyInsurancePolicyNumber,
  }
}
